import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import ReactStrapModal from 'containers/Time/Components/Modal'
import 'containers/Time/Components/EventForm.scss'
import { Col, Row, Button } from 'reactstrap'

import isEmpty from 'lodash/isEmpty'
import { getFrench } from 'containers/Time/Components/FrenchTranslation'
import { values } from 'lodash'
import { makeGetRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'
import { convertToMuiDate } from 'utils/helpers'

const CreateEventForm = ({
  isOpen = true,
  title = 'Ajout Event',
  fetchOperations,
  fetchEntretienHistoriques,
  setEventF,
  row,
}) => {
  const [categoryDD, setCategoryDD] = useState('')
  const [value, setValue] = useState({})

  useEffect(() => {
    setValue({
      start_date: convertToMuiDate(row.EstimatedDate),
      end_date: convertToMuiDate(row.EstimatedDate),
      start_time: null,
      end_time: null,
      lieux: '',
      participants: '',
      event_type: 'a',
      pays: 'Fr',
      designation: row.MaintenanceOperation,
      titre: row.IdMaintenanceplans?.EquipementName,
      operationm: row.id,
    })
    const fetchCategory = async () => {
      const response = await makeGetRequest('/api/time/get-category-dd', {}, true)
      if (response.status === 200) {
        const cat_id = response.data.filter((v) => v.name === 'Entretien')

        if (cat_id.length > 0) {
          // setCategoryDD(cat_id[0].id)
          setValue((value) => ({
            ...value,
            category_id: cat_id[0].id,
          }))
        }
      }
    }
    const fetchType = async () => {
      const response = await makeGetRequest('/api/time/get-event-type', {}, true)
      if (response.status === 200) {
        const cat_id = response.data.filter((v) => v.name === 'Maison')

        if (cat_id.length > 0) {
          // setCategoryDD(cat_id[0].id)
          setValue((value) => ({
            ...value,
            type_id: cat_id[0].id,
          }))
        }
      }
    }
    fetchCategory()
    fetchType()
  }, [])

  const validate = (values) => {
    const errors = {}
    if (!values.titre) {
      errors.titre = 'Required'
    } else if (values.titre.length > 255) {
      errors.titre = 'Must be 255 characters or less'
    }

    if (!values.lieux) {
      errors.lieux = 'Required'
    } else if (values.lieux.length > 50) {
      errors.lieux = 'Must be 20 characters or less'
    }

    if (!values.start_date) {
      errors.start_date = 'Required'
    }

    if (!values.end_date) {
      errors.end_date = 'Required'
    }
    if (!values.start_time) {
      errors.start_time = 'Required'
    }

    if (!values.end_time) {
      errors.end_time = 'Required'
    }
    return errors
  }
  //   useEffect( () => {
  //       setValue({
  //         start_date: '',
  //         end_date: '',
  //         start_time: null,
  //         end_time: null,
  //         lieux: '',
  //         participants: '',
  //         // defalult
  //         event_type:'a',
  //         category_id: '1',
  //         pays:'Fr',
  //         designation:'dsfs',
  //         titre : 'dsfsd',

  //       })
  //   }, [])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validate,
    onSubmit: async (values) => {
      const response = await makePostRequest('/api/time/events/', values, {}, true)

      if (response.status === 201) {
        fetchOperations()
        fetchEntretienHistoriques()
        // window.location.reload()
        setEventF(false)
      } else {
        setEventF(false)
      }
    },
  })

  //   const getTypeByCategory = (id) => {
  //     let types = categoryDD.find((x) => x.id.toString() === id)
  //     types && setTypeDD(types.type)
  //   }

  //   useEffect(() => {
  //     value && value.category_id && getTypeByCategory(value.category_id.toString())
  //   }, [value])

  return (
    <ReactStrapModal isOpen={isOpen} title={title} size="lg">
      <form
        onSubmit={formik.handleSubmit}
        style={{
          backgroundColor: '#E6E6E6',
          fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        }}
      >
        <Row>
          <Col md={2}>
            <label htmlFor="lieux">Lieux</label>
          </Col>
          <Col md={4}>
            <input
              id="lieux"
              name="lieux"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lieux}
              placeholder={'Lieux'}
            />
          </Col>
        </Row>
        {formik.errors.lieux ? <div>{formik.errors.lieux}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="start_date">Date de début</label>
          </Col>
          <Col md={4}>
            <input
              id="start_date"
              name="start_date"
              type="date"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.start_date}
            />
          </Col>
        </Row>
        {formik.errors.start_date ? <div>{formik.errors.start_date}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="start_time">Heure de début</label>
          </Col>
          <Col md={4}>
            <input
              id="start_time"
              name="start_time"
              type="time"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.start_time}
            />
          </Col>
        </Row>
        {formik.errors.start_time ? <div>{formik.errors.start_time}</div> : null}
        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="end_date">Date de fin</label>
          </Col>
          <Col md={4}>
            <input
              id="end_date"
              name="end_date"
              type="date"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.end_date}
            />
          </Col>
        </Row>
        {formik.errors.end_date ? <div>{formik.errors.end_date}</div> : null}

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="end_time">Heure de fin</label>
          </Col>
          <Col md={4}>
            <input
              id="end_time"
              name="end_time"
              type="time"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.end_time}
            />
          </Col>
        </Row>
        {formik.errors.end_time ? <div>{formik.errors.end_time}</div> : null}

        <br />
        <Row>
          <Col md={2}>
            <label htmlFor="participants">Participants</label>
          </Col>
          <Col md={4}>
            <input
              id="participants"
              name="participants"
              type="participants"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.participants}
              placeholder={'Participants'}
            />
          </Col>
        </Row>
        {formik.errors.participants ? <div>{formik.errors.participants}</div> : null}

        <br />
        <Button type="cancel" color="danger" size="lg" onClick={() => setEventF(false)}>
          Annuler
        </Button>
        <Button type="submit" size="lg" style={{ backgroundColor: '#5D86CC' }}>
          Soumettre
        </Button>
      </form>
    </ReactStrapModal>
  )
}

export default CreateEventForm
